<template>
  <div class="modal-holder">
    <!-- Product Region  -->
    <section class="product-region">
      <!-- Image Here -->
      <div class="image-region">
        <div class="image">
          <div class="image-holder">
            <img
              :src="photoURL(product.itemId)"
              alt="image"
              @error="handleBrokenImage($event)"
            />
          </div>
        </div>
      </div>

      <!-- Product Details -->
      <div class="product-details">
        <p class="price" v-if="product.price">${{ product.price }}</p>

        <div class="portrait-info">
          <div>
            <p class="pick">Select {{ retrieveSelection | capitalize }}</p>
            <input
              v-if="dropDownDisable()"
              type="text"
              disabled
              class="disabledVariant"
              :value="setValue(product.itemId).label"
            />
            <v-select
              v-else
              class="custom gift-select product"
              :class="{
                'invalid-input':
                  !setValue(product.itemId) && showValidationError
              }"
              :options="getVariantOptions(product)"
              :placeholder="`Select ${retrieveSelection}`"
              :clearable="false"
              :searchable="false"
              :disabled="dropDownDisable()"
              :value="setValue(product.itemId)"
              @input="data => updateProductVariant(data)"
              @open="$emit('isSelectOpen', true)"
              @close="$emit('isSelectOpen', false)"
            >
              <template #open-indicator="{ attributes }">
                <span v-bind="attributes"> <Dropdown /> </span>
              </template>
            </v-select>
          </div>

          <div
            class="validation-error"
            v-if="!setValue(product.itemId) && showValidationError"
          >
            <small>Please select an option.</small>
          </div>
        </div>
      </div>
    </section>

    <section class="button-region">
      <button class="finalize-button" @click="handleSelection">
        apply
      </button>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { handleBrokenImage, defaultNotFoundImage } from '@/helpers'
import Dropdown from '@/components/Universal/Dropdown.vue'

export default {
  name: 'Singleproduct',
  components: { Dropdown },

  props: {
    product: {
      type: Object,
      default: () => ({})
    },

    payload: {
      type: Array,
      default: () => []
    }
  },

  data: () => ({
    handleBrokenImage: handleBrokenImage,
    showValidationError: false
  }),

  computed: {
    ...mapState({
      selectedData: state => state.groupOrder.variantSelection
    }),

    retrieveSelection() {
      let pick = ''
      const { product_variants_list } = this.product.itemableAttributes
      const { data } = product_variants_list

      if (data.length) {
        const { attributes } = data[0]

        for (const key in attributes.spec) {
          if (attributes.spec[key]) {
            pick = key
          }
        }
      }

      return pick
    }
  },
  methods: {
    handleSelection() {
      this.showValidationError = true
      const enabled = this.setValue(this.product.itemId)

      if (enabled) {
        this.updateProductVariant(enabled)
        this.$emit('persistData')
      }
    },
    setValue(id) {
      const variant = this.selectedData[id]

      let options = this.getVariantOptions(this.product)

      let defaultSelectedOption = options.length <= 1 ? options[0] : null

      return variant ? variant : defaultSelectedOption
    },

    getVariantOptions(product) {
      let options = []

      const availableProduct =
        product.itemableAttributes &&
        product.itemableAttributes.product_variants_list &&
        product.itemableAttributes.product_variants_list.data

      if (availableProduct.length) {
        for (let index = 0; index < availableProduct.length; index++) {
          const variant = availableProduct[index].attributes

          options.push({
            code: parseInt(availableProduct[index].id),
            label: variant.name.toUpperCase(),
            hasInventory: variant.availableInventoryCount > 0,
            image: variant.images.length
              ? variant.images[0].url
              : defaultNotFoundImage
          })
        }
        return options.filter(option => option.hasInventory)
      }
    },

    updateProductVariant(data) {
      this.$emit('updateProductVariant', {
        itemId: this.product.itemId,
        ...data
      })
    },

    photoURL(id) {
      const variant = this.selectedData[id]
      const image =
        this.product.itemableAttributes &&
        this.product.itemableAttributes.default_product_variant_images

      const defaultProductImage = image.length
        ? image[0].url
        : defaultNotFoundImage

      if (variant) {
        return variant.image || defaultProductImage
      }
      return defaultProductImage
    },
    dropDownDisable() {
      const varientsCount = this.product.itemableAttributes
        .product_variants_list.data.length
      return varientsCount === 1
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/global.scss';
.portrait-info {
  bottom: 0;
  display: block;
  margin: 0 auto;
}

.disabledVariant {
  border: 1px solid;
  padding: 0em 0.5em 0em 1em;
  cursor: not-allowed;
}

.pick {
  color: #232220;
  font-size: 0.813rem;
  font-weight: bold;
  margin-bottom: 0.25rem;
}

.modal-holder {
  padding: 0 1.5rem;
  .product-region {
    margin-top: 2.5rem;
    display: flex;

    .image-region {
      width: 100%;
      height: 302px;

      .image {
        border: 1px solid #232220;
        padding: 0.75rem;
        height: 100%;
        width: 243px;
        display: flex;
        justify-content: center;
        align-items: center;

        .image-holder {
          height: 212px;

          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
      }
    }

    .product-details {
      width: 100%;
      text-align: left;
      .price {
        color: #25282a;
        font-size: 1.25rem;
        font-weight: bold;
        margin-bottom: 1rem;
      }

      .dropdown-holder {
        margin-bottom: 1rem;

        p {
          font-size: 0.813rem;
          color: #232220;
          font-weight: bold;
          margin-bottom: 0.25rem;
        }
      }
    }
  }

  .button-region {
    display: flex;
    justify-content: end;
    margin-top: 4rem;

    .finalize-button {
      background: #24292c;
      color: $main-white;
      font-size: 1rem;
      font-weight: normal;
      font-size: 0.813rem;
      height: 2.5rem;
      text-transform: uppercase;
      border-radius: 40px;
      padding: 0 2rem;
      display: flex;
      align-items: center;
      justify-content: center;

      &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }
    }
  }
}

@media (max-width: 575.98px) {
  .product-region {
    flex-wrap: wrap;
  }
  .image {
    width: 100% !important;
  }
  .price {
    margin-top: 1rem;
  }

  .button-region {
    padding-bottom: 5rem;
  }
}

@media (min-width: 576px) and (max-width: 767.98px) {
  .product-region {
    flex-wrap: wrap;
  }

  .image {
    width: 100% !important;
  }
  .price {
    margin-top: 1rem;
  }
  .button-region {
    padding-bottom: 5rem;
  }
}
</style>
